import * as block from './block'
import * as extractor from './extractor'
import * as inline from './inline'
export const rules = { block, inline, extractor }
